import React from "react";
import { GeoJsonLayer } from "@deck.gl/layers";

const kategorije = [
    { label: "Nepoznato", value: null },
    { label: "Javna rasvjeta 0,4 kV", value: "Javna rasvjeta 0,4 kV" },
    { label: "Domaćinstva 0,4 kV JT", value: "TG-1 (Domaćinstva 0,4 kV JT)" },
    { label: "Ostala potrošnja na 0,4 kV", value: "TG-1 (Ostala potrošnja na 0,4 kV)" },
    { label: "Domaćinstva 0,4 kV DT", value: "TG-2 (Domaćinstva 0,4 kV DT)" },
    { label: "Ostala potrošnja na 0,4 kV JT", value: "TG-2 (Ostala potrošnja na 0,4 kV JT)" },
    { label: "Ostala potrošnja na 0,4 kV DT", value: "TG-3 (Ostala potrošnja na 0,4 kV DT)" },
    { label: "Posebna grupa 0,4 kV JT", value: "TG-6 (Posebna grupa 0,4 kV JT)" },
    { label: "Posebna grupa 0,4 kV DT", value: "TG-7 (Posebna grupa 0,4 kV DT)" }
];

// Funkcija za generisanje različitih boja na osnovu indeksa
const getColorByIndex = (index) => {
    const colors = [
        [1, 25, 54, 255],    // Oxford plava
        [0, 255, 0, 255],    // Zelena
        [0, 0, 255, 255],    // Plava
        [255, 255, 0, 255],  // Žuta
        [255, 165, 0, 255],  // Narandžasta
        [128, 0, 128, 255],  // Ljubičasta
        [0, 255, 255, 255],  // Tirkizna
        [255, 192, 203, 255],// Roze
        [128, 128, 128, 255] // Siva
    ];
    return colors[index % colors.length]; // Osigurava rotaciju boja ako ih ima više od 9
};

const EnergyCard = ({ wfsLayers, setWfsLayers }) => {
    const handleEnergetskaKartica = (category, value, isChecked, index) => {
        const layerId = `${category.toLowerCase().replace(/\s+/g, '-')}-energetska-kartica-layer`;

        if (isChecked) {
            const mjernaMjestaLayer = wfsLayers.find(layer => layer.id === 'mjerna_mjesta-layer');

            if (mjernaMjestaLayer && mjernaMjestaLayer.props.data?.features) {
                const features = mjernaMjestaLayer.props.data.features;

                const filteredMjesta = features.filter(feature => {
                    if (category === "Nepoznato") {
                        return !feature.properties?.kategorija_potrosnje_grupa;
                    } else {
                        return feature.properties?.kategorija_potrosnje_grupa === value;
                    }
                });

                const newLayer = new GeoJsonLayer({
                    id: layerId,
                    data: {
                        type: 'FeatureCollection',
                        features: filteredMjesta
                    },
                    getFillColor: getColorByIndex(index),
                    getLineColor: getColorByIndex(index),
                    getPoint: 50,
                    pointRadiusMinPixels: 8,
                    pickable: true
                });

                setWfsLayers(prevLayers => [...prevLayers, newLayer]);
            }
        } else {
            setWfsLayers(prevLayers =>
                prevLayers.filter(layer => layer.id !== layerId)
            );
        }
    };

    return (
        <div className="sub-options">
            {kategorije.map((category, index) => {
                const color = getColorByIndex(index);
                const rgba = `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3] / 255})`;

                return (
                    <label className="toggle" key={category.label}>
                        <span>{category.label}</span>
                        <input
                            type="checkbox"
                            data-index={index}
                            onChange={(e) =>
                                handleEnergetskaKartica(
                                    category.label,
                                    category.value,
                                    e.target.checked,
                                    index
                                )
                            }
                        />
                        <span className={`slider energy-slider energy-index-${index}`}></span>
                    </label>
                );
            })}
        </div>
    );
};

export default EnergyCard;
